import { dataUserSettings } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserSettings = /*#__PURE__*/createIcon(dataUserSettings)
export default IconUserSettings
